export default __webpack_public_path__ + "static/media/work3.cc5759bb.png";